/**
 * Canonical routes for `servicesData` keys — must match App.jsx paths.
 */
const SERVICES_DATA_PATH = {
  transcriptomics: '/service/bioinformatics/transcriptomics',
  epigenomics: '/service/bioinformatics/epigenomics',
  massSpec: '/service/bioinformatics/mass-spectrometry',
  microbiome: '/service/bioinformatics/microbiome',
  genomics: '/service/bioinformatics/genomics',
  singleCell: '/service/bioinformatics/single-cell',
  spatialOmics: '/service/bioinformatics/spatial-omics',
  multiOmics: '/service/bioinformatics/multi-omics',
  pipelineDev: '/service/bioinformatics/pipeline-development',
  scientificWriting: '/service/scientific-writing',
  dataSecurity: '/service/data-security',
  patientStratification: '/service/ai-ml/patient-stratification',
  survivalRisk: '/service/ai-ml/survival-risk',
  biomarkerDiscovery: '/service/ai-ml/biomarker-discovery',
  cohortReanalysis: '/service/ai-ml/cohort-reanalysis',
  agricultureFood: '/service/consultancy/agriculture-food',
}

export function pathForServicesDataKey(key) {
  if (SERVICES_DATA_PATH[key]) return SERVICES_DATA_PATH[key]
  const kebab = key.replace(/([A-Z])/g, '-$1').toLowerCase()
  return `/service/${kebab}`
}
